export const peopleColumns = [
	{
		name: "name",
		label: "Name",
		type: "s"
	},
	{
		name: "height",
		label: "Height",
		type: "n"
	},
	{
		name: "mass",
		label: "Mass",
		type: "n"
	},
	{
		name: "created",
		label: "Created",
		type: "d"
	},
	{
		name: "edited",
		label: "Edited",
		type: "d"
	},
	{
		name: 'homeworld',
		label: 'Planet',
		type: 'u'
	}
];

export const planetColumns = [
	{
		name: "name",
		label: "Name"
	},
	{
		name: "diameter",
		label: "Diameter"
	},
	{
		name: "climate",
		label: "Climate"
	},
	{
		name: "population",
		label: "Population"
	}
];